export default {
  "token": {
    "colorPrimary": "#0086D6",
    "colorPrimaryBgHover": "#0086D6",
    "colorPrimaryBg": "#0086D6",
    "colorPrimaryTextActive": "#FFF"
  }
}